import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'
import * as types from '../types/index'

Vue.use(Vuex)

const state = {
  //当前用户加入得组织列表
  orgListByUser: [],
  // wps 链接
  wpsUrl: null,
  // 传递过来的信息
  routeInfo: {
    id: null,
    fileId: null,
    docId: null,
    rfsId: null,
    docSource: null,
    docName: null,
    docSize: null,
    version: null,
    lockState: null,
    isPC: null,
    projectId: null,
    groupId: null,
    from: null,
    to: null,
    seqId: null,
    // 用户登录信息
    userToken: null,
    crmId: null,
    orgId: null,
    userId: null,
    createBy: null,
    // 跳过权限验证
    skipPermission: null
  },
  // 全局状态
  globalStatus: {
    [types.globalStatus.online]: true,
    [types.globalStatus.serverError]: false,
  },
  // 系统权限
  systemPerm: [],
  // wps 记录日志的 data
  operationId: null
}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js